export enum NotificationTabsEnums {
  users = 'users',
  payment = 'payment',
  support = 'support',
  custom = 'custom',
}

export enum NotificationsModelTypeAdmin {
  reservationCreatedAdmin = 'App\\Notifications\\Reservation\\ReservationCreatedAdmin',
  userCreated = 'App\\Notifications\\User\\UserCreated',
  supportNotification = 'ChangeRequestCreated',
}
